__turbopack_context__.v({
  "popoverContent": "MoreItemsButton-module-scss-module__-kh4Kq__popoverContent",
  "popoverMenu": "MoreItemsButton-module-scss-module__-kh4Kq__popoverMenu",
  "root": "MoreItemsButton-module-scss-module__-kh4Kq__root",
  "showButton": "MoreItemsButton-module-scss-module__-kh4Kq__showButton",
  "tag": "MoreItemsButton-module-scss-module__-kh4Kq__tag",
});
